/**
 * Reads a {@link File} or {@link Blob} as a data URL (`data:<mime>;base64,...`)
 * for `<img src>` where CSP allows `data:` but not `blob:`.
 */
export function readFileAsDataUrl(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const { result } = reader;
      if (typeof result === 'string') {
        resolve(result);
        return;
      }
      reject(new Error('FileReader did not return a string'));
    };
    reader.onerror = () => {
      reject(reader.error ?? new Error('Failed to read file'));
    };
    reader.readAsDataURL(blob);
  });
}
